import { sanitizeHTML } from "@/lib/utils";
import { useEffect, useRef } from "react";

interface DeepPlaneVsStandardData {
  heading?: {
    text?: string;
    title?: string;
  };
  subheading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
}

interface DeepPlaneVsStandardProps {
  data: DeepPlaneVsStandardData;
}

export const fields = [
  "heading.text",
  "heading.title",
  "subheading.text",
  "subheading.title",
  "text.text"
] as const;

export default function DeepPlaneVsStandard({
  data,
}: DeepPlaneVsStandardProps) {
  const tableWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!tableWrapperRef.current) return;

    const table = tableWrapperRef.current.querySelector('table');
    if (!table) return;

    // Get column headers from the first row in tbody (which will be hidden on mobile)
    const firstRow = table.querySelector('tbody tr:first-child');
    if (!firstRow) return;

    const headers = Array.from(firstRow.querySelectorAll('td')).map(
      td => td.textContent?.trim() || ''
    );

    // Add data-label attributes to all tbody td elements (except first row)
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach((row, rowIndex) => {
      // Skip the first row (header row)
      if (rowIndex === 0) return;
      
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        if (headers[index]) {
          cell.setAttribute('data-label', headers[index]);
        }
      });
    });
  }, [data?.text?.text]);

  return (
		<section id='deep-plane-vs-standard' className='bg-[#f9f9f9] py-16'>
			<div className='container'>
				<h2
					className='text-center mb-6'
					dangerouslySetInnerHTML={sanitizeHTML(
						data?.heading?.text || data?.heading?.title || ''
					)}
				/>
				<p
					className='text-center mb-8 max-w-3xl mx-auto'
					dangerouslySetInnerHTML={sanitizeHTML(
						data?.subheading?.text || data?.subheading?.title || ''
					)}
				/>

				<div
					ref={tableWrapperRef}
					className='overflow-x-auto max-w-[1080px] mx-auto styled-table-wrapper grid gap-6'
					dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
				/>
			</div>
		</section>
	)
}
